import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getRolesById,
  redirectToRolesList,
  rolesListFetch,
  deleteRoles,
} from "pages/AccessManagement/actions";
import { ListHeader } from './components';
import { Header, SideBar, DeleteModal, DataTable } from "CommonComponent";
import AddUpdateModel from "../AddUpdateModel";
import RolesViewModal from "../View";
import AccessRights from 'utils/AccessRights';

const RoleList = () => {
  const dispatch = useDispatch();

  const session = useSelector(state => state.session || {});
  const rolesState = useSelector(state => state.rolesState || {});
  const rolesList = rolesState.rolesList || [];

  const [showViewModel, setShowViewModel] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [addEditmodalShow, setAddEditModalShow] = useState(true);

  const object_viewed_id = session?.current_page_permissions?.object_id || '';

  useEffect(() => {
    dispatch(rolesListFetch(object_viewed_id));
  }, [dispatch, object_viewed_id]);

  useEffect(() => {
    setShowViewModel(rolesState.showViewPage === true);
  }, [rolesState.showViewPage]);

  useEffect(() => {
    setAddEditModalShow(false);
    dispatch(rolesListFetch(object_viewed_id));
  }, [rolesState.redirect_to_list, dispatch, object_viewed_id]);

  useEffect(() => {
    setAddEditModalShow(rolesState.showUpdateForm === true);
  }, [rolesState.showUpdateForm]);

  useEffect(() => {
    setShowViewModel(rolesState.showViewForm === true);
  }, [rolesState.showViewForm]);

  const showViewPopup = (recordId) => {
    dispatch(getRolesById(recordId, 'view'));
  };

  const showUpdateForm = (recordId) => {
    dispatch(getRolesById(recordId, 'update'));
  };

  const hideViewModel = () => {
    dispatch(redirectToRolesList());
  };

  const hideAddUpdateModel = () => {
    setAddEditModalShow(false);
    dispatch(redirectToRolesList());
  };

  const deleteRecord = async (deleteRowId) => {
    await dispatch(deleteRoles(deleteRowId, object_viewed_id));
    setDeleteModalShow(false);
    await dispatch(rolesListFetch(object_viewed_id));
  };

  // --- Define columns for Common DataTable ---
  const columns = [
    {
      id: "name",
      header: "Role Name",
      accessor: (row) => row.name,
      sortable: true,
      searchable: true,
    },
    {
      id: "description",
      header: "Description",
      accessor: (row) => row.description || "-",
      sortable: true,
      searchable: true,
    },
    {
      id: "created_by",
      header: "Created By",
      accessor: (row) => row.created_by_name || "-",
      sortable: true,
      searchable: true,
    },
    {
      id: "actions",
      header: "Actions",
      accessor: null,
      cell: (_, row) => (
        <div className="d-flex align-items-center gap-2">
          {AccessRights(session.current_page_permissions, "view", row.created_by) && (
            <button
              className="p-0 border-0 bg-transparent"
              title="View"
              onClick={() => showViewPopup(row.id)}
            >
              <img src="/assets/images/view-icon.svg" alt="" />
            </button>
          )}
          {AccessRights(session.current_page_permissions, "edit", row.created_by) && (
            <button
              className="p-0 border-0 bg-transparent"
              title="Edit"
              onClick={() => showUpdateForm(row.id)}
            >
              <img src="/assets/images/edit-icon.svg" alt="" />
            </button>
          )}
          {AccessRights(session.current_page_permissions, "delete", row.created_by) && (
            <button
              className="p-0 border-0 bg-transparent"
              title="Delete"
              onClick={() => {
                setDeleteRowId(row.id);
                setDeleteModalShow(true);
              }}
            >
              <img src="/assets/images/delete-icon.svg" alt="" />
            </button>
          )}
        </div>
      ),
      sortable: false,
      searchable: false,
    },
  ];

  return (
    <div className="wrapper-div">
      <ListHeader
        setAddEditModalShow={setAddEditModalShow}
        addEditmodalShow={addEditmodalShow}
      />
      <div>
        <DataTable
          columns={columns}
          data={rolesList}
          serverSide={false}
          showSearch={true}
          className="object-list-table"
        />
      </div>
      <DeleteModal
        show={deleteModalShow}
        onDelete={() => deleteRecord(deleteRowId)}
        onHide={() => setDeleteModalShow(false)}
      />
      <RolesViewModal
        show={showViewModel}
        onHide={hideViewModel}
      />
      <AddUpdateModel
        show={addEditmodalShow}
        onHide={hideAddUpdateModel}
      />
    </div>
  );
};

export default RoleList;
